import Cookies from "js-cookie";

import { NonEmptyArray } from "@/data/models/NonEmptyArray";

export const parseIntFallback = (fallback: number, str?: string): number => {
  if (!str) return fallback;

  const t = parseInt(str);

  if (Number.isNaN(t)) return fallback;

  return t;
};

/**
 * shorthand to check for null and undefined and smart cast to `T`.
 * @param value
 */
export const isSet = <T>(value: T | null | undefined): value is T => {
  return value !== null && value !== undefined;
};

export const removeWhitespace = (str: string) => {
  return str.replace(/\s/g, "");
};

export const isEmpty = (str: string): str is string => {
  return removeWhitespace(str).length === 0;
};

export const isNotEmpty = (str: string): str is string => {
  return removeWhitespace(str).length > 0;
};

export const isSetAndNotEmpty = (
  str: string | null | undefined,
): str is string => {
  return isSet(str) && isNotEmpty(str);
};

export const hasElements = <T>(list: T[]): list is NonEmptyArray<T> => {
  return list.length > 0;
};

export const capitalizeEachWord = (sentence: string): string => {
  return sentence
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

type TokenPayload = {
  customerId: number;
  customer_guid: string;
  client: string;
};

export const decodeCustomerIdFromToken = (token: string | undefined) => {
  if (!token) return;

  const decodable = token.split(".")[1];

  if (!decodable) return;

  const tokenPayload = JSON.parse(atob(decodable)) as TokenPayload;

  return tokenPayload.customerId;
};

export function getCampaignParamsFromCookie() {
  const cookieValue = Cookies.get("campaign-query");
  if (!cookieValue) return null;

  const params = new URLSearchParams(cookieValue);
  return Object.fromEntries(params.entries());
}

export function getClickIdFromCookies() {
  const cookieValue = Cookies.get("campaign-query");
  if (!cookieValue) return;

  const params = new URLSearchParams(cookieValue);

  const gclid = params.get("gclid") ?? params.get("utm_gclid") ?? undefined;

  const fbclid = params.get("fbclid") ?? params.get("utm_fbclid") ?? undefined;

  return { gclid, fbclid };
}
